import { ReactNode } from 'react';
import Grid from '../Grid';
import Fade from '../Fade';
import Accordion, { AccordionDetails, AccordionSummary, IAccordionProps } from '../Accordion';
import { mergeSX } from '../../services/helpers';

export interface IExpandableSectionProps extends IAccordionProps {
  PrimaryTypographyComponent?: ReactNode;
  SecondaryTypographyComponent?: ReactNode;
}

const buildSX = () => ({
  '&.MuiAccordion-rounded': {
    boxShadow: 'none',
  },
  '& .MuiAccordionSummary-root': {
    padding: 0,
    '& .MuiAccordionSummary-content': {
      margin: 0,
      '&.Mui-expanded': {
        margin: 0,
      },
    },
  },
  '& .MuiAccordionDetails-root': {
    padding: 0,
  },
});

const ExpandableSection = (props: IExpandableSectionProps) => {
  const {
    children,
    PrimaryTypographyComponent = null,
    SecondaryTypographyComponent = null,
    expanded = false,
    ...restProps
  } = props;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Accordion
          disableGutters
          sx={mergeSX(buildSX())}
          expanded={expanded}
          {...restProps}
        >
          <AccordionSummary>
            <Grid container rowSpacing={0.5}>
              {
                !!PrimaryTypographyComponent && (
                  <Grid item xs={12}>
                    {PrimaryTypographyComponent}
                  </Grid>
                )
              }
              {
                !!SecondaryTypographyComponent && (
                  <Fade in={!expanded}>
                    <Grid item xs={12}>
                      {SecondaryTypographyComponent}
                    </Grid>
                  </Fade>
                )
              }
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            {children}
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

export default ExpandableSection;
